<template>
  <div class="concept-details" data-block-interaction @mousemove="updateMousePos" @mouseleave="onMouseLeave" @touchstart="updateMousePos" @touchmove="updateMousePos" >

    <div class="concept-header">
      <!-- <CloseIcon class="back-btn" @click.native="$emit('update:concept', null)" /> -->
      <span @click="$emit('update:concept', null)" class="back-btn" data-block-interaction>✕</span>

      <transition name="change-content" mode="out-in"><h1 :key="concept.id">{{concept.label}}</h1></transition>

      <span class="about-desktop hover-link" @click="onAboutClick" data-block-interaction>ABOUT</span>
    </div>

    <transition mode="out-in">
      <span @click="onAboutClick" class="about-mobile" data-block-interaction>i</span>
    </transition>

    <div class="centered-stuff">
      <transition name="change-content" mode="out-in"><h2 :key="concept.id">worldwide</h2></transition>

      <div class="control-arrows">
        <div class="arrow arrow-left" @click="onPrevClick"><ArrowPrev class="arrow-svg" /></div>
        <div class="arrow arrow-right" @click="onNextClick"><ArrowNext class="arrow-svg" /></div>
      </div>

      <StoneCanvas
        :width="titleStoneCanvasSize"
        :height="titleStoneCanvasSize"
        :concept="concept"
        :overrideActivity="graphActivity"
        :active="active"
      />
      <div class="align-left">

        <transition name="change-content" mode="out-in">
          <h2 :key="concept.id">interest over time</h2>
        </transition>
        <transition name="change-content" mode="out-in">
          <p v-if="visibleText" :key="concept.id">This is how people around the world searched for <span :style="{color: '#' + concept.categoryObject.color.toString(16)}">{{concept.entity}}</span> on Google in the past 2 years.</p>
        </transition>

        <InterestOverTimeGraph
          :concept="concept"
          :selectedIndex.sync="graphIndex"
          class="graph"
        />

        <transition name="change-content" mode="out-in"><h2 :key="concept.id">interest by region</h2></transition>
        <transition name="change-content" mode="out-in">
          <p v-if="visibleText" :key="concept.id">These are the top 6 locations in which the term <span :style="{color: '#' + concept.categoryObject.color.toString(16)}">{{concept.entity}}</span> was most popular during the past 2 years.</p>
        </transition>

        <div
          class="interest-region"
          v-for="interest in concept.interestByRegion"
          @mouseenter="onMouseEnter($event, interest)"
          @mouseleave="onMouseLeave"
          @touchstart="onMouseEnter($event, interest)"
          @touchmove="onMouseMove($event)"
          @touchend="onMouseLeave"
        >
          <StoneCanvas
            class="interest-region-canvas"
            :width="interestCanvasStyle"
            :height="interestCanvasStyle"
            :concept="interestByRegionConcept(interest)"
            :active="active"
          />
          <transition name="interest-region-label" mode="out-in"><div class="interest-region-label" :key="concept.id">{{interest.name}}</div></transition>
        </div>
      </div>
    </div>

    <!-- <transition> -->
      <div class="interest-region-popup" v-show="interestOver" :style="{transform: 'translate(' + mouse.x + 'px, ' + mouse.y + 'px)'}" >
        <div class="title" :style="{color: '#' + concept.categoryObject.color.toString(16)}"><span>{{concept.label}}</span></div>
        <div class="country"><span>{{interestOver ? interestOver.name : ''}}</span></div>
        <div class="search-interest">
          <span class="label">SEARCH<br>INTEREST</span>
          <span class="interest" :style="{color: '#' + concept.categoryObject.color.toString(16)}">{{interestOver ? Math.round(interestOver.interest * 100) : ''}}</span>
        </div>
      </div>
    <!-- </transition> -->

  </div>
</template>

<script>
import Platform from '@/platform'
import StoneCanvas from '@/atoms/StoneCanvas'
import InterestOverTimeGraph from '@/molecules/InterestOverTimeGraph'
import Viewport from '@/mixins/Viewport'
import MarkdownBlock from '@/atoms/MarkdownBlock'
import ElButton from 'element-ui/packages/button'
import cssVars from '@/_variables.scss'

import ArrowNext from '@/assets/img/arrow-dx.svg'
import ArrowPrev from '@/assets/img/arrow-sx.svg'

import CloseIcon from '@/assets/img/close_button.svg'

export default {
  name: 'ConceptDetailsPanel',
  mixins: [Viewport],
  components: {
    StoneCanvas,
    InterestOverTimeGraph,
    MarkdownBlock,
    ElButton,
    ArrowNext,
    CloseIcon,
    ArrowPrev
  },
  data: function () {
    return {
      graphIndex: -1,
      visibleText: true,
      active: true,
      mouse: {x: 0, y: 0},
      interestOver: null
    }
  },
  props: {
    concept: {
      type: Object,
      required: true
    }
  },
  activated: function () {
    this.active = true

    if (Platform.ios) {
      window.addEventListener('resize', this.onIphoneResize.bind(this))
    }
  },
  deactivated: function () {
    this.active = false

    if (Platform.ios) {
      window.removeEventListener('resize', this.onIphoneResize.bind(this))
    }
  },
  methods: {
    onIphoneResize () {
      this.visibleText = false

      setTimeout(() => {
        this.visibleText = true
      })
    },
    onMouseLeave (event, interest) {
      setTimeout(() => {
        this.interestOver = null
      }, 100)
    },
    onMouseMove (event) {
      if (this._timeout) {
        clearTimeout(this._timeout)
      }
    },
    onMouseEnter (event, interest) {
      this._timeout = setTimeout(() => {
        this.interestOver = interest
      }, 100)
    },
    onAboutClick () {
      this.$emit('about:click')
    },
    onNextClick () {
      this.$emit('concept:prev')
    },
    onPrevClick () {
      this.$emit('concept:next')
    },
    updateMousePos: function (event) {
      let x = event.touches && event.touches.length > 0 ? event.touches[0].pageX : event.pageX
      let y = event.touches && event.touches.length > 0 ? event.touches[0].pageY : event.pageY

      let leftSide = this.viewPort.width > parseInt(cssVars.bpSm) ? this.viewPort.width / 2 : 0
      if (this.viewPort.height <= y + 110) {
        y -= ((y + 100) - this.viewPort.height) + 50
      }

      this.mouse.x = Math.min(this.viewPort.width - 280, x) - leftSide
      this.mouse.y = y
    },
    interestByRegionConcept: function (interest) {
      return {
        id: this.concept.id,
        category: this.concept.category,
        categoryObject: this.concept.categoryObject,
        activity: interest.interest,
        label: interest.name
      }
    }
  },
  computed: {
    graphActivity: function () {
      let value = this.concept.activity
      let trend = this.concept.trend
      if (this.graphIndex !== -1) {
        let interest = this.concept.interestOverTime[this.graphIndex].interest
        let prevIndex = Math.max(0, this.graphIndex - 1)
        let prevInterest = this.concept.interestOverTime[prevIndex].interest
        value = interest
        trend = interest > prevInterest ? 1 : -1
      }
      return {value, trend}
    },
    titleStoneCanvasSize: function () {
      let width = this.viewPort.width > parseInt(cssVars.bpSm) ? this.viewPort.width / 2 : this.viewPort.width
      return Math.min(250, Math.min(width, this.viewPort.height) * 0.8) - 40
    },
    interestCanvasStyle: function () {
      let width = this.viewPort.width > parseInt(cssVars.bpSm) ? this.viewPort.width / 2 : this.viewPort.width
      return width * 0.3333
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';
@import 'mixins';




$inter-block-margin: 25px;
$transition-length: 0.3s;

.concept-details {
  position: absolute;
  width: 100%;
  height: 100%;
  // background: linear-gradient(to bottom, $c-light-brown, $c-brown);
  background-color: $c-background;
  z-index: $z-ui;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;


  @include breakpoint(#{$bp-sm}px) {
    width: 50%;
    left: 50%;
    box-shadow: 0px 0px 50px color-alpha($c-dark-brown, 0.3);
  }
}

// .align-left {
//   text-align: left;
// }

.concept-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  font-weight: 700;
  color: #808184;
  font-size: 14px;
  background-color: #f9f8f7;
  box-sizing: border-box;

  @include breakpoint(#{$bp-sm}px) {
    border-bottom: 1px solid #ddd;
  }
}

.about-mobile {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  line-height: 50px;
  border-left: 1px solid $c-silver;
  padding-left: 22px;
  padding-right: 22px;
  z-index: $z-header;

  @include breakpoint(#{$bp-sm}px) {
    display: none;
  }
}

.about-desktop {
  display: none;
  position: absolute;
  right: 0;
  padding-left: 20px;
  padding-right: 20px;
  top: 0;
  line-height: #{$header-height}px;
  cursor: pointer;
  z-index: $z-ui;
  letter-spacing: 2px;
  font-weight: 600;

  transition: opacity 0.3s $ease-out-quad;

  &:hover {
    opacity: 0.6;
  }

  @include breakpoint(#{$bp-sm}px) {
    display: block;
  }
}

h1 {
  text-transform: uppercase;
  font-size: 15px;
  position: absolute;
  letter-spacing: 1px;
  display: block;
  text-align: center;
  width: 100%;
  left: 0;
  box-sizing: border-box;
  font-weight: 600;
  pointer-events: none;
  padding: 0 40px;
  // top: -2px;
  line-height: 50px;
  transform: none;

  @include breakpoint(#{$bp-sm}px) {
    font-size: 19px;
    // top: -8px;
  }

  .no-hiddenscroll & {
    padding-right: 58px;
  }
}

h2 {
  margin: 60px 0 30px;
  text-transform: uppercase;
  color: $c-gray;
  font-size: 14px;
  letter-spacing: 2px;
  font-weight: 600;

  @include breakpoint(#{$bp-sm}px) {
    margin: 80px 0 25px;
  }

  // &:nth-child(1) {
  //   margin-top: 10px;
  // }
}

p {
  font-size: 16px;
  line-height: 22px;
  color: $c-gray;
  margin: 0;
  margin-bottom: $inter-block-margin;
  font-weight: 400;

  @include breakpoint(#{$bp-sm}px) {
    padding: 0 5%;
  }
}

.back-btn {
  position: absolute;
  cursor: pointer;
  font-size: 20px;
  // stroke: #a4a3a3;
  color: #a4a3a3;
  width: 20px;
  height: 20px;
  padding: 16px;
  letter-spacing: 2px;

  transition: opacity 0.3s $ease-out-quad;

  @include breakpoint(#{$bp-sm}px) {
    padding: 15px;
  }

  &:hover {
    opacity: 0.6;
  }
}

.description-text {
  p {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
    // letter-spacing: 0.5px;
    color: $c-black;
  }
}
.centered-stuff {
  padding: 0 20px;
  text-align: center;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  top: 50px;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid $c-silver;
  padding-bottom: 50px;

  @include breakpoint(#{$bp-sm}px) {
    position: absolute;
    // top: inherit;
    // height: 92%;
    top: 50px;
    bottom: 0;
    height: 95%;
    border-top: inherit;
    padding: 0 90px;
  }
}

.arrow-svg {
  width: 15px;
  fill: none;
  stroke: #808184;
}

.graph {
  width: 92%;
  height: 120px;
  margin: 30px auto;

  @include breakpoint(#{$bp-sm}px) {
    width: 100%;
    height: 120px;
  }
}

.interest-region {
  display: inline-block;
  width: calc(50% - 20px);
  padding-top: 50%;
  box-sizing: border-box;
  margin: 10px;
  position: relative;
  @include breakpoint(#{$bp-sm}px) {
    width: calc(33% - 20px);
    padding-top: 33%;
  }
}

.interest-region-canvas {
  position: absolute;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 50%;
  max-height: 50%;

  @include breakpoint(#{$bp-sm}px) {
    max-width: 70%;
    max-height: 70%;
  }
}

.interest-region-label {
  color: $c-gray;
  position: absolute;
  top: 10%;
  left: 50%;
  pointer-events: none;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 2px;
  font-weight: 700;
  user-select: none;
}


.change-content-enter-active,
.change-content-leave-active,
.interest-region-label-enter-active,
.interest-region-label-leave-active {
  transition: opacity $transition-length $ease-in-out-quad, transform $transition-length $ease-in-out-quad;
}

.change-content-enter,
.change-content-leave-to,
.interest-region-label-enter,
.interest-region-label-leave-to {
  opacity: 0;
}

// .change-content-enter {
//   transform: translate(0, -30px);
// }
// .change-content-leave-to {
//   transform: translate(0, 30px);
// }

// .interest-region-label-enter {
//   transform: translate(-50%, -30px);
// }
// .interest-region-label-leave-to {
//   transform: translate(-50%, 30px);
// }

.control-arrows {
  position: absolute;
  left: 0;
  top: 22%;
  width: 100%;

  @include breakpoint(#{$bp-sm}px) {
    display: none;
  }

  .arrow {
    &.arrow-left {
      float: left;
      margin-left: 25px;
    }

    &.arrow-right {
      float: right;
      margin-right: 25px;
    }
  }
}


.interest-region-popup {
  position: absolute;
  pointer-events: none;
  display: table;
  top: 0;
  left: 0;
  background-color: $c-white;
  border-radius: 10px;
  box-shadow: 1px 3px 18px color-alpha($c-black, 0.3);
  vertical-align: middle;
  min-width: 180px;
  max-width: 280px;

  .title,
  .country,
  .search-interest {
    display: table-row;
    text-transform: uppercase;
    letter-spacing: 1px;

    user-select: none;
  }

  .title,
  .country {
    span {
      vertical-align: middle;
      // text-align: center;
      display: table-cell;
      padding: 10px 10px 5px;
    }
  }

  .country span {
    padding: 0 10px;
  }

  .country {
    font-weight: 600;
  }

  .search-interest {
    display: table;
    width: 100%;

    .label,
    .interest {
      display: table-cell;
      vertical-align: middle;
      padding: 10px;
    }

    .label {
      font-size: 13px;
      line-height: 16px;
      color: $c-gray;
      font-weight: 700;
      padding: 5px 10px 10px;
    }

    .interest {
      font-size: 21px;
      font-weight: 600;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/organisms/ConceptDetailsPanel.vue